<template>
  <div class="row">
    <div @click="getStreamPath" />
    <div v-if="showPath">
      <div
        v-if="this.manufacturer && camera.gpu"
        class="urls"
      >
        Stream Paths:
        <div class="column">
          <div>
            <div class="label">
              Low:
            </div>
            {{ this.streams.low }}
          </div>
          <div v-if="this.streams.high">
            <div class="label">
              High:
            </div>
            {{ this.streams.high }}
          </div>
        </div>
        <owal-button @click="emitStreamPath">
          Click To Confirm
        </owal-button>
      </div>
      <div
        v-else
        class="error"
      >
        Remember to make sure a manufacturer or GPU Type is selected
      </div>
    </div>
  </div>
</template>

<script>
import * as OwalUI from '@/libraries/owal-ui'
import { hikvisionNVRStreamHigh, hikvisionNVRStreamLow, hikvisionIPStreamHigh, hikvisionIPStreamLow, axisStreamHigh, axisStreamLow, unvStreamLow, tviStreamHigh } from '@/libraries/onboard/streams'

export default {
  name: 'StreamPaths',
  props: {
    manufacturer: {
      type: String,
    },
    isNVR: {
      type: Boolean,
    },
    saveHigh: {
      type: Boolean,
    },
    camera: {
      type: Object,
    },
    channelNumber: {
      type: Number,
    },
  },
  data () {
    return {
      streams: {
        high: '',
        low: '',
      },
      clipStorageHighCPE: undefined,
      showPath: false,
    }
  },
  methods: {
    getStreamPath () {
      console.log(`manufacturer: ${this.manufacturer}`)
      if (this.manufacturer === 'Hikvision') {
        if (this.isNVR) {
          if (this.saveHigh) {
            this.streams.high = hikvisionNVRStreamHigh(this.camera.address, this.camera.port, this.channelNumber)
          }
          this.streams.low = hikvisionNVRStreamLow(this.camera.address, this.camera.port, this.channelNumber)
        } else {
          if (this.saveHigh) {
            this.streams.high = hikvisionIPStreamHigh(this.camera.address, this.camera.port)
            this.clipStorageHighCPE = `local://l/1/${this.domainFname}`
          }
          this.streams.low = hikvisionIPStreamLow(this.camera.address, this.camera.port)
        }
      } else if (this.manufacturer === 'TVI') {
        if (this.isNVR) {
          // there is no low stream
          console.log('nvr tvi')
          this.streams.high = tviStreamHigh(this.camera.address, this.camera.port, this.channelNumber)
          console.log(`high: ${this.streams.high}`)
        } else {
          alert(`ERROR: TVI Cameras must be accessed through the NVR`)
        }
      } else if (this.manufacturer === 'Axis') {
        if (this.isNVR) {
          if (this.saveHigh) {
            this.streams.high = axisStreamHigh(this.camera.address, this.camera.port)
          }
          this.streams.low = axisStreamLow(this.camera.address, this.camera.port)
        } else {
          if (this.saveHigh) {
            this.streams.high = axisStreamHigh(this.camera.address, this.camera.port)
          }
          this.streams.low = axisStreamLow(this.camera.address, this.camera.port)
        }
      } else if (this.manufacturer === 'UNV') {
        if (!this.isNVR) {
          this.streams.low = unvStreamLow(this.camera.address, this.camera.port, this.channelNumber)
        } else this.streams.low = 'UNV Cameras should be accessed through internal IP addresses'
      }
      this.showPath = true
      return 0
    },
    emitStreamPath () {
      this.$emit('streams', this.streams)
      this.$emit('highClipStorage', this.clipStorageHighCPE)
      this.showPath = false
    },
  },
  components: {
    ...OwalUI,
  },
}
</script>

<style scoped>
.column {
  display: flex;
  flex-direction: column;
  margin-left: 5px;
  margin-right: 5px;
  color: white;
}
.urls {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px;
  border-radius: 15px;
  background-color: rgba(50, 64, 87, .6);
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12),
              0 2px 4px 0 rgba(0,0,0,0.08);
  margin: 10px;
  transition-timing-function: ease-out;
  /* A litttttle slower on the way in */
  transition: 0.25s;
}
.error {
  font-size: 16px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 15px;
  border-radius: 15px;
  background-color: red;
  color: white;
  box-shadow: 0 4px 8px 0 rgba(0,0,0,0.12),
              0 2px 4px 0 rgba(0,0,0,0.08);
  margin: 10px;
  transition-timing-function: ease-out;
  /* A litttttle slower on the way in */
  transition: 0.25s;
}
.label {
  font-weight: bold;
}
</style>
